/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCountDownProps } from './type';

export const countDownDefaultProps: TdCountDownProps = {
  autoStart: true,
  content: 'default',
  format: 'HH:mm:ss',
  millisecond: false,
  size: 'medium',
  splitWithUnit: false,
  theme: 'default',
  time: 0,
};
